<template>
  <label class="custom-checkbox" :for="id" :disabled="disabled">
    <input
      :id="id"
      type="checkbox"
      class="custom-control-input"
      :disabled="disabled"
      :name="name"
      :checked="isChecked"
      :value="value"
      :class="{ 'me-1': withGap }"
      @change="updateInput"
    />
    <span class="custom-control-label">
      {{ label ?? null }}
    </span>
  </label>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    value: { type: String },
    id: { type: String, required: false },
    name: { type: String, required: false },
    modelValue: { default: '' },
    label: { type: String, required: false },
    trueValue: { default: true },
    falseValue: { default: false },
    disabled: { default: false },
    withGap: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }
      return this.modelValue === this.trueValue
    },
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue]
        if (isChecked) {
          newValue.push(this.value)
        } else {
          newValue.splice(newValue.indexOf(this.value), 1)
        }
        this.$emit('change', newValue)
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue)
      }
    },
  },
}
</script>
